/**
 * TBD
 * Product Area: PROMO_MODALS
 */
export const APP_PROMOTION_BANNER_LINKS = 'APP_PROMOTION_BANNER_LINKS';
